export { default as Img200 } from './processed/200/Conan.jpg';
export { default as Img400 } from './processed/400/Conan.jpg';
export { default as Imgthumb } from './processed/thumb/Conan.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Conan.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Conan.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      204,
      100
    ],
    "_population": 2,
    "_hsl": [
      0.12745098039215685,
      0.781609195402299,
      0.6588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      233,
      214,
      163
    ],
    "_population": 250,
    "_hsl": [
      0.12142857142857146,
      0.614035087719298,
      0.776470588235294
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      92,
      48,
      19
    ],
    "_population": 19,
    "_hsl": [
      0.06621004566210047,
      0.6576576576576576,
      0.21764705882352942
    ]
  },
  "Muted": {
    "_rgb": [
      155,
      115,
      78
    ],
    "_population": 734,
    "_hsl": [
      0.0800865800865801,
      0.33047210300429175,
      0.4568627450980392
    ]
  },
  "LightMuted": {
    "_rgb": [
      204,
      204,
      172
    ],
    "_population": 1,
    "_hsl": [
      0.16666666666666666,
      0.23880597014925378,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      96,
      70,
      48
    ],
    "_population": 1357,
    "_hsl": [
      0.07638888888888891,
      0.3333333333333333,
      0.2823529411764706
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Conan.js